import React, {useEffect, useMemo} from "react";
import {inject, observer} from "mobx-react";
import {useTranslation} from "react-i18next";
//local
import InviteForm from "./InviteForm/InviteForm";
import {Preloader} from "components/Preloader";
import EmptyData from "components/EmptyData";
import {CounterStrip} from "components/CounterStrip";
import {PaginationType} from "components/Pagination";
import {inviteCountersData, inviteTableHead} from "constants/invite.consts";
import {InviteSuppliersTableHead} from "./InviteSuppliersTableHead";
import {InviteSuppliersTableRow} from "./InviteSuppliersTableRow";
import {scrollToTopClassname} from "helpers/helper";

export const InviteSuppliers = inject("store")(
  observer(({store: {buyer, organization}}) => {
    const {t} = useTranslation();
    const {invites, loading} = organization;

    const suppliers = useMemo(
      () =>
        invites?.organizationInvites?.length
          ? invites.organizationInvites.map((invite) => ({
              email: invite.email,
              companyName: invite.companyName,
              organizationName: invite.InvitedOrganization?.name,
              organizationLink: invite.InvitedOrganization
                ? `/organizations/${invite.InvitedOrganization?.id}`
                : "",
              sent: invite.createdAt,
              signedup: invite.signedAt,
              requestName: invite.Request?.name,
              requestLink: `/requests/${invite.Request?.id}`,
              message: invite.message ?? "",
            }))
          : [],
      [invites?.organizationInvites]
    );

    const inviteCounters = useMemo(
      () => inviteCountersData.map((item) => ({...item, value: invites[item.key]})),
      [invites]
    );

    const handlePageChange = (pageNumber) => {
      organization.getInvites(pageNumber);
      scrollToTopClassname("invite-suppliers_table-title");
    };

    useEffect(() => {
      organization.getInvites();
    }, [organization]);

    return (
      <div className="invite-suppliers_wrapper">
        <h6 className="custom-title">{t("SEND_INVITE_TO_SUPPLIERS_TITLE")}</h6>
        <InviteForm organizationStore={organization} buyerStore={buyer} />

        <div className="invite-suppliers_table-title">
          <h6 className="custom-title">{t("SENT_INVITES")}</h6>
          {!loading && <CounterStrip counters={inviteCounters} />}
        </div>
        <InviteSuppliersTableHead list={inviteTableHead} />
        {loading && <Preloader addClass="preloader100" />}
        {!loading && (
          <React.Fragment>
            {suppliers.length ? (
              suppliers.map((supplier) => (
                <InviteSuppliersTableRow
                  key={`${supplier.email}${supplier.sent}`}
                  data={supplier}
                />
              ))
            ) : (
              <EmptyData />
            )}
          </React.Fragment>
        )}
        <PaginationType
          totalItems={invites.totalItems}
          currentPage={invites.currentPage}
          onPageChange={handlePageChange}
          addClass="mt-4"
        />
      </div>
    );
  })
);
